import React from 'react';

export const Link = ({links}) => {
    return (
        <div className="link-container">
            {links.map((item, index) => (
                <a key={index} href={item.link} target="_blank" rel="noopener noreferrer">
                    <img src={item.logo} alt="logo"/>
                </a>
            ))}
        </div>
    );
};